import type React from "react";
import {memo, useCallback} from "react";

import {ChevronRightIcon} from "../../react/components/Icons/ChevronRightIcon";
import {HStack} from "../ui/hstack";
import {Pressable} from "../ui/pressable";
import {Text} from "../ui/text";

type Props = {
    id: string;
    label: string;
    count?: number;
    onPress?: (id: string) => void;
};

const ListingGroupItem: React.FC<Props> = ({id, label, count, onPress}) => {
    const handlePress = useCallback(() => {
        onPress?.(id);
    }, [id, onPress]);

    return (
        <Pressable
            className={`
                flex
                flex-row
                items-center
                justify-between
                gap-2
                p-2
                rounded-sm
                hover:bg-blueGray-100
                focus:bg-blueGray-100
              `}
            testID="listing-group-item"
            onPress={handlePress}
        >
            <HStack className="flex-1">
                <Text isTruncated variant="sm">
                    {label}&nbsp;
                </Text>
                {!!count && (
                    <Text className="flex-grow-0 flex-shrink-0" variant="sm">
                        {`(${count})`}
                    </Text>
                )}
            </HStack>
            <ChevronRightIcon className="flex-shrink-0 md:hidden" fill="blueGray.800" size="md" />
        </Pressable>
    );
};

export default memo(ListingGroupItem);
